import { render, staticRenderFns } from "./ImportsTable.vue?vue&type=template&id=b709f402"
import script from "./ImportsTable.vue?vue&type=script&lang=js"
export * from "./ImportsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports